function fill (v, key) {
  let fillStr = key ? key+'' : '0';
  return (v+'').length > 1 ? v : fillStr + v;
}
export default function(Vue) {
  Vue.filter('els', function(v, len) {    // 截取省略
    if(!v) return '';
    return len && len > 0 ? v.substring(0, len)+'..' : v.substring(0, 15)+'..'
  })

  Vue.filter('time', function(v, fillKey, isAll) {    // 截取省略
    if(!v) return '';
    var t = new Date(v);
    var part1 = t.getFullYear() +'-'+ fill(t.getMonth()+1, fillKey) +'-'+ fill(t.getDate(), fillKey)
    var part2 = fill(t.getHours(), fillKey) +'-'+ fill(t.getMinutes, fillKey) +'-'+ fill(t.getSeconds(), fillKey)
    return isAll ? (part1 + ' ' + part2) : part1
  })
  Vue.filter('timeNoS', function(v) {    // 截取省略
    if(!v) return '';
    var t = new Date(v);
    var part1 = t.getFullYear() +'-'+ fill(t.getMonth()+1) +'-'+ fill(t.getDate())
    var part2 = fill(t.getHours()) +':'+ fill(t.getMinutes())
    return part1 + ' ' + part2
  })

  Vue.filter('size', function(v) {    // 文件大小处理处理展示
    if(!v) return '';
    if(v > 1024*1024) return (v/(1024*1024) - 0).toFixed(2) + 'M';
    else if(v > 1024) return (v/(1024) - 0).toFixed(2) + 'KB';
    else return v.toFixed(2) + 'B';
  })

  Vue.filter('date', function(v, str) {    // 文件大小处理处理展示
    if(!v) return '';
    return (v+'').slice(0, 10).replace(/-/g, str)
  })
  
  Vue.filter('fmtFee', (money, type) => {
    if (!money) return type ? '00' : 0
    const minus = money < 0 // 是否负数
    money = Math.abs(money)
    if (!type) {
        let arr = (Math.floor(money) + '').split('').reverse()
        let a = []
        arr.forEach((el, i) => {
            a.push(el)
            if((i+1) % 3 == 0 ) a.push(',')
        })
        let str = a.reverse().join('')
        let data = str.charAt(0) == ',' ? str.slice(1): str
        return minus ? '-' + data : data
    } else {
        money = (money - 0).toFixed(2)
        const sp = (money + '').split('.')
        const dec = sp[1]
        if (sp.length > 1) return dec.length === 1 ? dec + '0' : dec
        return '00'
    }
  })
}